/* eslint-disable import/no-anonymous-default-export */
import _find from 'lodash/find';
import KoButton from 'packages/button';
import KoIcon from '@kwapio/icons';
import KoPriority from 'packages/priority';
import KoTooltips from 'packages/tooltips';
import { KoDescription, KoText } from 'packages/typography';
import styles from '../kanban.module.scss';
import { getCookie } from 'shared/utils/cookies';
import { Link } from 'react-router-dom';
import KoBadge from 'packages/badge';
import KoDP from 'packages/dp';

export default function({ children: card, source, workflow, dragging, allowRemoveCard, onCardRemove,onCardClick }) {

  let issueType = _find(workflow, function(o) { return o.value === (card?.issueType || card?.type); }) || {};
 
 
  console.log('card----------',card);

  const onCellClick = (row, source) => {
    onCardClick && onCardClick(row, source);
  };



  return (
    source ==='customers' ? <div className={`${styles.cusCard} ${dragging ? styles.kanbaCardDragging : ''}`}>
      <div className={styles.cardTitle}>
        <div className={`${card?.status ===1 ? styles.unpaid : styles.paid}`}>
          <KoIcon name={'BillableOutlined'} />
          <KoText text={card?.status ===1 ? 'Unpaid' : 'Paid'} />
        </div>
        <KoDescription className={styles.summary} text={`${card.firstName + ' ' + card.lastName}, ${card.email} ${card.designation}`}
          ellipsis={{
            rows: 2
          }}
        />
        <div className={styles.contentTags}>
          <KoTooltips title={'Open'}>
            <div className={`${styles.contentTagsInfo} ${styles.open}`} onClick={() => { onCellClick(card, 'open'); }} >
              <KoButton ellipsis={true} label={card?.summary} type="default" className={`${styles.btnLarge}`} icon={<KoIcon width={16} height={16} name={'ClientsOutlined'} />}/>
            </div>
          </KoTooltips>
          {card?.commentsCount > 0 && <div className={styles.contentTagsFile}>
            <KoTooltips title={'Comments'}>
              <KoBadge color={card?.commentsCount > 0 ? `var(--palette-primary-main)` : ''} count={card?.commentsCount} >
                <KoButton iconBtn={true} type="default" className={`${styles.btn}`} icon={<KoIcon width={16} height={16} name='ChatOutlined' />} onClick={() => { onCellClick(card, 'comments'); }} />
              </KoBadge>
            </KoTooltips>
          </div>}
        </div>
      </div>
    </div> :
      card.summary && <div className={`${styles.card} ${dragging ? styles.kanbaCardDragging : ''}`}>
        <div className={styles.cardTitle}>
          {card?.priority ? <div className={`${styles.priority} ${styles['priority' + card?.priority]}`}>
            <KoPriority size={'small'} value={card?.priority} />
            <KoTooltips title={card?.assigneeName}>
              <div className={styles.assignee}>
                {card?.['logo']?  <KoDP className={styles.dp} width={24} height={24} logo={card?.['logo']} /> :
                  <div className={`${styles.circle}  ${card ?
                    card?.assigneeName?.charAt(0).toLowerCase() : 'a'}`}>
                    <KoText className={`${styles.letter} fs-size-11`} text={card?.assigneeName?.charAt(0)} />
                  </div>}
              </div>
            </KoTooltips>
          </div> : ''}
          <KoDescription className={styles.summary} text={card.summary}
            ellipsis={{
              rows: 2
            }}
          />
          <div className={styles.contentTags}>
            <KoTooltips title={'Open'}>
              <div className={styles.contentTagsInfo} >
                <Link target="_blank" to={`/open/ticket/${getCookie("accountId")}/${card?.workspace}/${card?.ticketId}`}>
                  <KoButton label={card?.id} type="default" className={`${styles.btnLarge}`} icon={<KoIcon width={16} height={16} name={issueType?.icon} />}/>
                </Link>
              </div>
            </KoTooltips>
            {card?.subTask &&  <div className={styles.contentTagsFile}>
              <KoTooltips title={'Subtask'}>
                <KoButton iconBtn={true} type="default" className={`${styles.btn}`} icon={<KoIcon width={16} height={16} name='TreeOutlined' />} onClick={() => { onCellClick(card, 'subtask');}} />
              </KoTooltips>
            </div>}
            {card?.commentsCount > 0 && <div className={styles.contentTagsFile}>
              <KoTooltips title={'Comments'}>
                <KoBadge color={card?.commentsCount > 0 ? `var(--palette-primary-main)` : ''} count={card?.commentsCount} >
                  <KoButton iconBtn={true} type="default" className={`${styles.btn}`} icon={<KoIcon width={16} height={16} name='ChatOutlined' />} onClick={() => { onCellClick(card, 'comments'); }} />
                </KoBadge>
              </KoTooltips>
            </div>}
          </div>
        </div>
      </div>
  );
}
